import React from "react";
import PropTypes from "prop-types";
import { setDangerousHtml, isServer } from "@lib/helpers";
import FlixMediaProductDescription from "@components/ProductPage/ProductDescription/FlixMediaProductDescription";

const StaticHTMLProductDescription = ({ staticHTML, ean, brand }) => {
  // Check if the description contains a FlixMedia description
  if (staticHTML.includes("data-flix") && ean && brand) {
    return (
      <FlixMediaProductDescription
        staticHTML=""
        contentEditorBlock=""
        content
        ean={ean}
        brand={brand}
      />
    );
  }

  return isServer ? (
    <div dangerouslySetInnerHTML={{ __html: staticHTML }} />
  ) : (
    <div ref={setDangerousHtml.bind(null, staticHTML)} />
  );
};

StaticHTMLProductDescription.propTypes = {
  staticHTML: PropTypes.string.isRequired,
  ean: PropTypes.string.isRequired,
  brand: PropTypes.string.isRequired,
};

export default StaticHTMLProductDescription;
